import { timelineEras } from "@/mocks/timeline";
import SectionHeading from "./SectionHeading";

export default function TimelineSection() {
  return (
    <section
      id="timeline"
      className="section-anchor w-full bg-background-100 border-y border-background-200/70"
    >
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-7xl mx-auto">
          <SectionHeading
            eyebrow="改编电影大全"
            title="按年代梳理的潘金莲改编电影脉络"
            desc="把不同阶段的作品放在同一条时间线上，可以更直观地看到这一题材是如何从片厂古装片，一步步走向文艺改写、系列化、长篇剧集与网络影像的。"
          />

          <ol className="mt-10 relative border-l border-background-300/70 ml-3 md:ml-4">
            {timelineEras.map((era) => (
              <li key={era.id} className="relative pl-6 md:pl-10 pb-8 last:pb-0">
                <span className="absolute -left-[9px] top-1.5 w-4 h-4 rounded-full bg-accent-500 border-4 border-background-100"></span>
                <div className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-heading text-sm md:text-base font-bold text-primary-700">
                      {era.era}
                    </span>
                    <span className="px-2.5 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-900">
                      {era.tag}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-lg md:text-xl font-semibold text-foreground-950">
                    {era.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                    {era.text}
                  </p>
                </div>
              </li>
            ))}
          </ol>

          <p className="mt-6 text-xs md:text-sm text-foreground-500 leading-relaxed">
            时间线用于呈现题材演变的整体趋势，各阶段之间常有交叠，部分作品的具体年份以正式发行资料为准。
          </p>
        </div>
      </div>
    </section>
  );
}